<template>
  <form-request
    v-if="src"
    :action="src"
    method="post"
    v-slot="{ update, submit, errors }"
  >
    <popup-form
      title="Transfer Package From Source"
      button="Transfer"
      :show="show"
      @close="$emit('close')"
      @confirm="transferPackage(update, submit)"
    >
      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <error
          :errors="errors"
          name="location"
        />
        <select
          v-model="form.location"
          name="location"
        >
          <template v-for="location in locationList">
            <!--                        <option :value="null">{{ defaultLocationName }}</option>-->
            <option :value="location.id">{{ location.name }}</option>
          </template>
        </select>
      </div>

      <div class="input-group col-span-12 sm:col-span-4">
        <error
          :errors="errors"
          name="quantity"
        />
        <input
          type="text"
          name="quantity"
          v-model="form.quantity"
        />
      </div>
    </popup-form>
  </form-request>
</template>

<script>
import PopupForm from '@/Components/Forms/PopupForm'
import FormRequest from '@/Components/Forms/FormRequest'
import Error from '@/Components/Forms/Error'
import accessesCompany from '@/Mixins/accessesCompany'

export default {
  mixins: [accessesCompany],
  emits: ['close'],
  components: {
    PopupForm,
    FormRequest,
    Error
  },

  props: {
    /**
     * If true we display the form
     */
    show: {
      type: Boolean,
      default: false
    },

    /**
     * A list of locations we can transfer a package to
     */
    locations: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * The amount of product available to transfer
     */
    available: {
      type: Number,
      default: 0
    },

    /**
     * The route to send the transfer request to. If null we can't send a package and thus don't show the form
     */
    src: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      // The form that gets submitted to the server
      form: {
        location: null,
        quantity: this.available
      }
    }
  },

  computed: {
    /**
     * Returns a list of locations with a default value at the beginning
     */
    locationList() {
      return [{ name: 'Select A Location', id: null }, ...this.locations]
    }
  },

  methods: {
    /**
     * Submits transfer request to the server
     * @param update a function (passed by form-request) that sets the values to send to the server
     * @param submit a function (passed by form-request) that submits the form
     */
    transferPackage(update, submit) {
      this.$emit('close')
      update({ ...this.form })
      submit()
    }
  }
}
</script>
